import React from 'react';
import PropTypes from 'prop-types';

import AppContext from './appContext';
import { ModerationConfig } from '../models';

export default function AppContextProvider({ children }) {
    const [context, _setContext] = React.useState({});

    const setContext = React.useCallback((ctx = {}) => {
        _setContext(context => {
            return { ...context, ...ctx };
        });
    }, []);

    const removeFromContext = React.useCallback(name => {
        _setContext(context => {
            let newContext = { ...context };
            delete newContext[name];
            return newContext;
        });
    }, []);

    ModerationConfig.useApiModel(
        {
            organizationId: context.organization?.id,
            launch: Boolean(context?.organization?.id),
            onSuccess: response => setContext({ moderationConfig: response })
        },
        [context.organization?.id]
    );

    return (
        <AppContext.Provider
            value={{
                context,
                setContext,
                removeFromContext
            }}
        >
            {children}
        </AppContext.Provider>
    );
}

AppContextProvider.propTypes = {
    children: PropTypes.node
};
